(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("DotnetFormat", [], factory);
	else if(typeof exports === 'object')
		exports["DotnetFormat"] = factory();
	else
		root["DotnetFormat"] = factory();
})(this, function() {
return 